import { map } from 'rxjs/operators';

import { setLocationHref } from './actions';
import { hrefChange$ } from './domEvents';

export default function createLocationHrefChanges() {
  return hrefChange$.pipe(map(locationHref => setLocationHref({ locationHref })));
}
